import { motion, useReducedMotion } from "framer-motion";

const WHILE_IN_VIEW = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, margin: "-80px" };
const EASE = [0.4, 0, 0.2, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => {
  const reduce = useReducedMotion();
  const initial = reduce ? false : { opacity: 0, y };
  const transition = { duration: 0.6, delay, ease: EASE };
  return (
    <motion.div
      className={className}
      initial={initial}
      whileInView={WHILE_IN_VIEW}
      viewport={VIEWPORT}
      transition={transition}
    >
      {children}
    </motion.div>
  );
};
